import type { FaireProductEntity } from "../../entity_types/product";

export const p_xbsd7fj5h4: FaireProductEntity = {
  token: "p_xbsd7fj5h4",
  type: "product",
  name: "Simulated Soap Squishy Slow Rebound Squeeze Fidget Toys",
  brandToken: "b_fau7y3uv8k",
  brandName: "MIAS SHOP",
  imageUrl:
    "https://cdn.faire.com/fastly/13e19a5dd9a432640c55ebbd4ac4d181393eae4ada7cff0df69dbb0f6e63c145.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/39207a9c3cd07d160445117021e8be033511697f765ea56f119bfa861fffea4f.jpeg",
    "https://cdn.faire.com/fastly/dfe8f9fe66e518d7b5319509440a71480ca3d3e5d602189291587c29d8c3dabf.jpeg",
    "https://cdn.faire.com/fastly/cda9276558843865a528f60e1e371ab4d570945ef5acc8e1201455d0c7e5fa1c.jpeg",
    "https://cdn.faire.com/fastly/be6cb0cc20d884479a9c64cbcdadf2b45a12c039e36d6511729e107dd601a087.jpeg",
  ],
  priceDollars: 3.28,
  description:
    "Weight: 30G\nSize: 9.5*6*3.5CM.\nColor:pink,blue,white.\nSimulated Soap Squishy Slow Rebound Squeeze Fidget Toys, you can never squeeze it into shape., It always returns to its original appearance.\nAnti stress balls let you squeeze, pull, and squish them in your hands to help reduce stress, anxiety, keep calm, and train our attention! Great for all ages! Unique color vibrant engaging combinations! Take yours home today! ",
  tags: [],
  msrpDollars: 6.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:44.110Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
